module.exports = __webpack_public_path__ + "static/media/Flight_Briefing_solutions_image.ff02ae7d.jpg";